import ResetPassworSuccessfulPopup from "./ResetPassworSuccessfulPopup";

export default ResetPassworSuccessfulPopup;